/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import AbDetectionController from 'components/analytics/ab-detection-controller';
EezyStimulusApplication.register('ab-detection', AbDetectionController);

import GoogleTagManagerController from 'components/analytics/google-tag-manager/google-tag-manager-controller';
EezyStimulusApplication.register('google-tag-manager', GoogleTagManagerController);

import EventTrackerController from 'components/analytics/conversions/event-tracker-controller';
EezyStimulusApplication.register('event-tracker', EventTrackerController);

import FormAnalyticsController from 'components/analytics/conversions/form-analytics-controller';
EezyStimulusApplication.register('form-analytics', FormAnalyticsController);

import ClickTrackController from 'controllers/click-track-controller';
EezyStimulusApplication.register('click-track', ClickTrackController);

import SearchAnalyticsController from 'components/analytics/search/search-analytics-controller';
EezyStimulusApplication.register('search-analytics', SearchAnalyticsController);
